/**
 * Returns whether the table should be condensed based on row size.
 * Defaults to true (condensed) if rowProps is not defined.
 */
export function isTableCondensed({
  rowProps
}) {
  if (!(rowProps !== null && rowProps !== void 0 && rowProps.rowSize)) {
    return true;
  }
  return rowProps.rowSize !== 'medium';
}